import { useEffect, useState } from "react";

const SMART_TV_PATTERNS = [
  /SMART-TV/i,
  /SMARTTV/i,
  /tizen/i,
  /webos/i,
  /apple ?tv/i,
  /bravia/i,
  /netcast/i,
  /hbbtv/i,
  /android tv/i,
  /smart[-\s]?tv/i,
];

const hasSmartTvUserAgent = (agent = "") =>
  SMART_TV_PATTERNS.some((pattern) => pattern.test(agent));

const getInitialState = (minWidth) => {
  if (typeof window === "undefined") {
    return false;
  }
  const agent = typeof navigator !== "undefined" ? navigator.userAgent : "";
  return window.innerWidth >= minWidth || hasSmartTvUserAgent(agent);
};

export default function useSmartTvScreen(minWidth = 1000) {
  const [isTvScreen, setIsTvScreen] = useState(() => getInitialState(minWidth));

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const agent = () => (typeof navigator !== "undefined" ? navigator.userAgent : "");
    const mediaQuery = window.matchMedia(`(min-width: ${minWidth}px)`);
    const updateState = () => {
      setIsTvScreen(mediaQuery.matches || hasSmartTvUserAgent(agent()));
    };

    updateState();

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", updateState);
    } else {
      mediaQuery.addListener(updateState);
    }

    window.addEventListener("resize", updateState);

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", updateState);
      } else {
        mediaQuery.removeListener(updateState);
      }
      window.removeEventListener("resize", updateState);
    };
  }, [minWidth]);

  return isTvScreen;
}
